import React from 'react';
import { Box, styled, keyframes } from '@mui/material';
import colors from 'src/utils/colors';

// Pulsing animation for the bottom dot
const pulse = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 0.5;
  }
`;

const TimelineContainer = styled(Box)({
  position: 'relative',
  width: '22px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

interface SideDotsWithBarProps {
  animateBottomDot?: boolean;
  hasShowMore?: boolean;
}

export const SideDotsWithBar: React.FC<SideDotsWithBarProps> = ({ 
  animateBottomDot = false,
  hasShowMore = false
}) => {
  const bottomOffset = hasShowMore ? 122 : 72;
  const lineHeightOffset = hasShowMore ? 130 : 80;

  return (
    <TimelineContainer >
      {/* Vertical connecting line */}
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '10px',
          width: '1px',
          backgroundColor: colors.darkBlue,
          transform: 'translateX(-50%)',
          height: `calc(100% - ${lineHeightOffset}px)`
        }}
      />
      
      {/* Top dot - centered with first version title (line-height 20px, so center at 10px) */}
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '10px', 
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: colors.darkBlue,
          transform: 'translate(-50%, -50%)',
          zIndex: 2
        }}
      />

      {/* Bottom dots container - aligned with last section title */}
      <Box
        sx={{
          position: 'absolute',
          bottom: `${bottomOffset}px`, 
          left: '50%',
          transform: 'translate(-50%, 50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Static base dot - 6px */}
        <Box
          sx={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            backgroundColor: colors.darkBlue,
            zIndex: 2
          }}
        />
        {/* Animated overlay dot - 12px */}
        {animateBottomDot && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: colors.darkBlue,
              zIndex: 3,
              animation: `${pulse} 2s infinite cubic-bezier(0.4, 0, 0.6, 1)`
            }}
          />
        )}
      </Box>
    </TimelineContainer>
  );
};
